<template>
  <BModal
    :active.sync="show"
    :on-cancel="cancelModal"
    has-modal-card
    trap-focus
    :can-cancel="false"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
  >
    <div
      id="report-container"
      :key="valueUpdate"
      class="modal-card modal-confirm modal-report-value"
      style="width: auto"
    >
      <section class="modal-card-body">
        <div class="modal-report">
          <div class="close-button" @click="cancelModal">
            <span class="close-button__text">Cerrar</span>
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_close.png" alt="close" width="12" />
          </div>
          <div class="grid-pc">
            <div class="modal-report__header">
              <HeaderPostMatch
                :headerInfoPostMatch="headerInfoPostMatch"
                :headerDate="headerDate"
                v-if="versionReport == 1"
                :live="game.is_live"
                :matchlapse="matchlapse_status"
              />
              <HeaderPreMatchNoReferee
                :headerDate="headerDate"
                :teams="teams"
                v-if="versionReport == 2"
                :live="game.is_live"
                :matchlapse="matchlapse_status"
              />
              <HeaderPreMatchWithReferee
                :live="game.is_live"
                :matchlapse="matchlapse_status"
                :headerDate="headerDate"
                :teams="teams"
                :referee="referee"
                :type="0"
                v-if="versionReport == 3"
              />
            </div>
            <div class="modal-report__for-periods">
              <TableActiveTimeByLapses
                v-if="Object.keys(infoTimePerLapse).length > 0 && versionReport == 1"
                :infoTimePerLapse="infoTimePerLapse"
              />
            </div>
            <div class="modal-report__table-events">
              <TableEventsTeams
                v-if="Object.keys(infoInactiveTime).length > 0"
                :infoInactiveTime="infoInactiveTime"
                :type="versionReport"
                :teams="teams"
                :tournament="tournament"
              />
            </div>
            <div class="modal-report__table-events-refeere">
              <TableEventsReferee :matchday="matchday" :infoEventReferee="infoEventReferee" :type="versionReport" />
            </div>
            <div class="modal-report__cont-possession">
              <div class="modal-report__cont-possession__noball">
                <GraphicPossessionWithoutBall
                  v-if="Object.keys(infoGraphPosession).length > 0"
                  :infoGraphPosession="infoGraphPosession"
                  :teamsNames="teamsNames"
                  :is-pre-match="isPreMatch"
                />
              </div>
              <div class="modal-report__cont-possession__withball">
                <TablePossession
                  v-if="Object.keys(infoPosession).length > 0"
                  :infoPosession="infoPosession"
                  :type="versionReport"
                  :matchday="matchday"
                />
              </div>
            </div>
            <div class="modal-report__cont-tables-categories">
              <div class="modal-report__cont-tables-categories__bandas">
                <TableEventsCategory
                  v-if="Object.keys(infoThrowIns).length > 0"
                  title="SAQUES DE BANDA"
                  :info="infoThrowIns"
                  :teams="teams"
                />
              </div>
              <div class="modal-report__cont-tables-categories__metas">
                <TableEventsCategory
                  v-if="Object.keys(infoGoalKicks).length > 0"
                  title="SAQUES DE META"
                  :info="infoGoalKicks"
                  :teams="teams"
                />
              </div>
            </div>
            <div class="modal-report__cont-btn-export">
              <div
                class="btn-export-pdf"
                v-if="game && game.season_id >= 1694 && versionReport == 1"
                @click="downloadWithVueResource"
              >
                <div>Exportar como PDF</div>
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icnpdf.png" />
              </div>
            </div>
          </div>
          <div class="grid-mobile">
            <div class="modal-report__cont-title-mobile"><HeaderTitle :version="version" /></div>
            <div class="modal-report__cont-menu-mobile">
              <div class="menu-switch-buttons">
                <div
                  :class="selectedComponent == 'Generales' ? 'active-menu-switch-buttons' : ''"
                  class="menu-switch-buttons__teams "
                  @click="onSectionSelect('Generales')"
                >
                  Generales
                </div>
                <div
                  :class="
                    versionReport == 2
                      ? 'deactivate'
                      : selectedComponent == 'Arbitrales' && versionReport != 2
                      ? 'active-menu-switch-buttons'
                      : ''
                  "
                  class="menu-switch-buttons__reefere"
                  @click="onSectionSelect('Arbitrales')"
                >
                  Arbitrales
                </div>
                <div
                  :class="selectedComponent == 'Eventos' ? 'active-menu-switch-buttons' : ''"
                  class="menu-switch-buttons__events"
                  @click="onSectionSelect('Eventos')"
                >
                  Eventos
                </div>
              </div>
            </div>
            <div class="modal-report__cont-generals-mobile" v-if="selectedComponent == 'Generales'">
              <div class="modal-report__cont-generals-mobile__header">
                <HeaderDate
                  v-if="versionReport != -1"
                  :headerDate="headerDate"
                  :live="game.is_live"
                  :matchlapse="matchlapse_status"
                />
                <br />
                <template v-if="versionReport == 1"
                  ><HeaderPostmatchGame
                    :headerInfoPostMatch="headerInfoPostMatch"
                    :live="game.is_live"
                    :matchlapse="matchlapse_status"
                /></template>
                <template v-if="versionReport == 2"
                  ><HeaderPreMatchNoReferee
                    :headerDate="headerDate"
                    :teams="teams"
                    :live="game.is_live"
                    :matchlapse="matchlapse_status"
                /></template>
                <template v-if="versionReport == 3"
                  ><HeaderPreMatchWithReferee
                    :headerDate="headerDate"
                    :teams="teams"
                    :referee="referee"
                    :type="1"
                    :live="game.is_live"
                    :matchlapse="matchlapse_status"
                /></template>
              </div>
              <div class="modal-report__cont-generals-mobile__for-periods">
                <TableActiveTimeByLapses
                  v-if="Object.keys(infoTimePerLapse).length > 0 && versionReport == 1"
                  :infoTimePerLapse="infoTimePerLapse"
                />
              </div>
              <div class="modal-report__cont-generals-mobile__cont-possession">
                <div class="modal-report__cont-generals-mobile__cont-possession__noball">
                  <GraphicPossessionWithoutBall
                    v-if="Object.keys(infoGraphPosession).length > 0"
                    :infoGraphPosession="infoGraphPosession"
                    :teamsNames="teamsNames"
                    :is-pre-match="isPreMatch"
                  />
                </div>
                <div class="modal-report__cont-generals-mobile__cont-possession__withball">
                  <TablePossession
                    v-if="Object.keys(infoPosession).length > 0"
                    :type="versionReport"
                    :matchday="matchday"
                    :infoPosession="infoPosession"
                  />
                </div>
              </div>
            </div>
            <div class="modal-report__cont-refeeres-mobile" v-if="selectedComponent == 'Arbitrales'">
              <div class="modal-report__cont-refeeres-mobile__header-refeere">
                <HeaderDate
                  v-if="versionReport != -1"
                  :headerDate="headerDate"
                  :live="game.is_live"
                  :matchlapse="matchlapse_status"
                /><br />
                <template v-if="versionReport == 1"
                  ><HeaderPostmatchReferee
                    :headerInfoPostMatch="headerInfoPostMatch"
                    :live="game.is_live"
                    :matchlapse="matchlapse_status"
                /></template>
                <template v-if="versionReport == 3"
                  ><HeaderPreMatchWithReferee
                    :headerDate="headerDate"
                    :teams="teams"
                    :referee="referee"
                    :type="2"
                    :live="game.is_live"
                    :matchlapse="matchlapse_status"
                /></template>
              </div>
              <div class="modal-report__cont-refeeres-mobile__table-events-refeere">
                <TableEventsReferee :matchday="matchday" :infoEventReferee="infoEventReferee" :type="versionReport" />
              </div>
            </div>
            <div class="modal-report__cont-events-mobile" v-if="selectedComponent == 'Eventos'">
              <HeaderDate
                v-if="versionReport != -1"
                :headerDate="headerDate"
                :live="game.is_live"
                :matchlapse="matchlapse_status"
              /><br />
              <div class="modal-report__cont-events-mobile__table-events">
                <TableEventsTeams
                  v-if="Object.keys(infoInactiveTime).length > 0"
                  :infoInactiveTime="infoInactiveTime"
                  :teams="teams"
                  :tournament="tournament"
                />
              </div>
              <div class="modal-report__cont-events-mobile__table-bandas">
                <TableEventsCategory
                  v-if="Object.keys(infoThrowIns).length > 0"
                  title="SAQUES DE BANDA"
                  :info="infoThrowIns"
                  :teams="teams"
                />
              </div>
              <div class="modal-report__cont-events-mobile__table-saques">
                <TableEventsCategory
                  v-if="Object.keys(infoGoalKicks).length > 0"
                  title="SAQUES DE META"
                  :info="infoGoalKicks"
                  :teams="teams"
                />
              </div>
            </div>
            <div class="modal-report__cont-btn-export">
              <div
                class="btn-export-pdf"
                v-if="game && game.season_id >= 1694 && versionReport == 1"
                @click="downloadWithVueResource"
              >
                <div>Exportar como PDF</div>
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icnpdf.png" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </BModal>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Report',
  components: {
    HeaderPostMatch: () => import('@/components/ActiveTime/Elements/ReportSections/HeaderPostMatch'),
    HeaderPreMatchNoReferee: () => import('@/components/ActiveTime/Elements/ReportSections/HeaderPreMatchNoReferee'),
    GraphicPossessionWithoutBall: () =>
      import('@/components/ActiveTime/Elements/ReportSections/GraphicPossessionWithoutBall'),
    HeaderPreMatchWithReferee: () =>
      import('@/components/ActiveTime/Elements/ReportSections/HeaderPreMatchWithReferee'),
    TableActiveTimeByLapses: () => import('@/components/ActiveTime/Elements/ReportSections/TableActiveTimeByLapses'),
    TableEventsReferee: () => import('@/components/ActiveTime/Elements/ReportSections/TableEventsReferee'),
    HeaderPostmatchReferee: () =>
      import('@/components/ActiveTime/Elements/ReportSections/Elements/HeaderPostmatchReferee'),
    HeaderDate: () => import('@/components/ActiveTime/Elements/ReportSections/Elements/HeaderDate'),
    TableEventsTeams: () => import('@/components/ActiveTime/Elements/ReportSections/TableEventsTeams'),
    TableEventsCategory: () => import('@/components/ActiveTime/Elements/ReportSections/TableEventsCategory'),
    TablePossession: () => import('@/components/ActiveTime/Elements/ReportSections/TablePossession'),
    HeaderTitle: () => import('@/components/ActiveTime/Elements/ReportSections/Elements/HeaderTitle'),
    HeaderPostmatchGame: () => import('@/components/ActiveTime/Elements/ReportSections/Elements/HeaderPostmatchGame'),
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    version: {
      type: Number,
      default: 1,
    },
    game: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    game: {
      immediate: true,
      handler: async function(newValue) {
        if (newValue) {
          if (newValue.is_live == 1) {
            this.versionReport = 1;
            this.isLiveReportFlag = true;
            setTimeout(() => {
              this.loopLiveReport();
            }, 10000);
          } else {
            this.isLiveReportFlag = false;
          }
          await this.getReportInfo(newValue.game_id);
        }
      },
    },
  },
  computed: {
    isPreMatch() {
      if (this.game) {
        return this.game.game_status === 4 && !this.game.is_live;
      }
      return true;
    },
  },
  data() {
    return {
      versionReport: -1,
      selectedComponent: 'Generales',
      urlData: 'https://rwtfu33saa.execute-api.us-east-2.amazonaws.com/prod/ta/analysis/',
      date: '',
      headerDate: {},
      valueUpdate: 0,
      headerInfoGame: {},
      infoTimePerLapse: {},
      infoEventReferee: {},
      infoPosession: {},
      infoGoalKicks: {},
      headerInfoPostMatch: {},
      infoThrowIns: {},
      teams: {},
      infoInactiveTime: {},
      referee: {},
      infoGraphPosession: {},
      teamsNames: {},
      game_status: 1,
      matchday: null,
      matchlapse_status: -1,
      tournament: null,
      isLiveReportFlag: false,
    };
  },
  methods: {
    loopLiveReport() {
      if (this.isLiveReportFlag) {
        setTimeout(() => {
          this.getReportInfo(this.game.game_id);
          this.loopLiveReport(this.isLiveReportFlag);
        }, 60000);
      }
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.game.game_id + '.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadWithVueResource() {
      axios({
        method: 'get',
        url: 'https://golstatsimages.blob.core.windows.net/reportes-tiempo-activo/' + this.game.game_id + '.pdf',
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response);
        })
        .catch(e => console.error(e));
    },

    cancelModal() {
      this.$emit('onCancel');
      this.versionReport = -1;
      this.selectedComponent = 'Generales';
      this.date = '';
      this.headerDate = {};
      this.headerInfoGame = {};
      this.infoTimePerLapse = {};
      this.infoEventReferee = {};
      this.infoPosession = {};
      this.infoGoalKicks = {};
      this.headerInfoPostMatch = {};
      this.infoThrowIns = {};
      this.teams = {};
      this.infoInactiveTime = {};
      this.referee = {};
      this.infoGraphPosession = {};
      this.teamsNames = {};
      this.game_status = 1;
      this.matchday = null;
      this.matchlapse_status = -1;
      this.valueUpdate += 1;
    },
    onSectionSelect(sectionComponent) {
      if (!(this.version == 2 && sectionComponent == 'Arbitrales')) {
        this.selectedComponent = sectionComponent;
      }
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    async getReportInfo(game) {
      const dataReport = await axios
        .get(this.urlData + game)
        .then(response => response)
        .catch(e => {
          if (this.retries > 0) {
            this.retries = this.retries - 1;
            return this.getReportInfo();
          }
          return e;
        });
      var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

      this.date =
        dataReport.data.matchday_name.replace('Matchday', 'Jornada') +
        ', ' +
        new Date(dataReport.data.date_time_utc)
          .toLocaleDateString('es-MX', options)
          .replace('de', '')
          .replace('de', '')
          .replace(', ', ' ') +
        ', ' +
        this.formatAMPM(new Date(dataReport.data.date_time_utc)).toUpperCase();
      this.headerDate = { date: this.date, stadium: dataReport.data.stadium_name };
      var effectiveTime = dataReport.data.effective_time.split(':');

      this.headerInfoPostMatch = {
        effective_time_min: effectiveTime[0],
        effective_time_seg: effectiveTime[1],
        visiting_team: dataReport.data.visiting_team,
        home_team: dataReport.data.home_team,
        score: dataReport.data.score,
        home_goals_minutes: dataReport.data.home_goals_minutes,
        home_yellow_cards_minutes: dataReport.data.home_yellow_cards_minutes,
        home_red_cards_minutes: dataReport.data.home_red_cards_minutes,
        visiting_goals_minutes: dataReport.data.visiting_goals_minutes,
        visiting_yellow_cards_minutes: dataReport.data.away_yellow_cards_minutes,
        visiting_red_cards_minutes: dataReport.data.away_red_cards_minutes,
        matchlapses: dataReport.data.matchlapses,
        referee: { referee_id: dataReport.data.referee.referee_id, referee_name: dataReport.data.referee.referee_name },
      };
      this.infoTimePerLapse = dataReport.data.active_time_per_lapses;
      this.infoEventReferee = dataReport.data.referee;
      this.infoPosession = dataReport.data.posession;
      this.infoGoalKicks = dataReport.data.goal_kicks;
      this.infoThrowIns = dataReport.data.throw_ins;
      this.teams = { home_team: dataReport.data.home_team, visiting_team: dataReport.data.visiting_team };
      this.infoInactiveTime = dataReport.data.inactive_time;
      this.referee = { id: dataReport.data.referee.referee_id, name: dataReport.data.referee.referee_name };
      this.infoGraphPosession = dataReport.data.posessions_matchlapses;
      this.teamsNames = { home: dataReport.data.home_team_name, away: dataReport.data.visiting_team_name };
      this.matchday = dataReport.data.matchday_name;
      this.tournament = dataReport.data.tournament;
      this.matchlapse_status = dataReport.data.matchlapse_status ? dataReport.data.matchlapse_status : -1;
      if ((this.game.game_status >= 0 && this.game.game_status < 4) || this.game.is_live == 1) {
        this.versionReport = 1;
      }
      if (this.game.game_status == 4 && this.game.is_live == 0) {
        if (this.referee.id == 0 && this.referee.name == 'Sin asignar') {
          this.versionReport = 2;
        } else {
          this.versionReport = 3;
        }
      }
    },
  },
};
</script>
<style>
.report .animation-content {
  max-width: 1083px !important;
}
@media screen and (max-width: 1100px) {
  .report .animation-content {
    max-width: 1000px !important;
  }
}
@media screen and (max-width: 1030px) {
  .report .animation-content {
    max-width: 900px !important;
  }
}
@media screen and (max-width: 930px) {
  .report .animation-content {
    max-width: 800px !important;
  }
}
@media screen and (max-width: 830px) {
  .report .animation-content {
    max-width: 720px !important;
  }
}
@media screen and (max-width: 740px) {
  .report .animation-content {
    max-width: 620px !important;
  }
}
</style>
<style lang="scss" scoped>
.btn-export-pdf {
  border-radius: 6px;
  box-shadow: 0 1px 2.5px 0 rgba(0, 0, 0, 0.11);
  background-color: #132739;
  width: 224px;
  height: 40px;
  display: none;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.56;
  letter-spacing: -0.32px;
  text-align: center;
  color: #fff;
  font-family: 'Avenir-Medium';
  img {
    margin-left: 7px;
  }
  &:hover {
    background: #132839;
    cursor: pointer;
    opacity: 0.9;
  }
}
.deactivate {
  background: rgb(201, 201, 201) !important;
  color: rgb(143, 143, 143) !important;
  cursor: default;
  &:hover {
    background: rgb(201, 201, 201) !important;
    color: rgb(143, 143, 143) !important;
    cursor: default;
  }
}
.active-menu-switch-buttons {
  background: #cbee6a;
  color: #132839;
  cursor: default !important;
}
.menu-switch-buttons {
  width: 90%;
  height: 29px;
  display: inline-flex;
  border-radius: 4px;
  overflow: hidden;
  font-family: 'Avenir-Demi';
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 29px;
  letter-spacing: -0.32px;
  text-align: center;
  border: solid 1px #cbfb48;
  @media screen and (max-width: 400px) {
    font-size: 13px;
    width: 100%;
  }
  &__teams {
    width: 33.33%;
    color: #132839;
    &:hover {
      background: #cbee6a;
      color: #132739;
      cursor: pointer;
    }
  }
  &__reefere {
    width: 33.33%;
    color: #132839;
    border-right: 1px solid #cbfb48;
    border-left: 1px solid #cbfb48;
    &:hover {
      background: #cbee6a;
      color: #132739;
      cursor: pointer;
    }
  }
  &__events {
    width: 33.33%;
    color: #132839;
    &:hover {
      background: #cbee6a;
      color: #132739;
      cursor: pointer;
    }
  }
}
.grid-mobile {
  display: none;
  @media screen and (max-width: 830px) {
    display: block;
  }
}
.grid-pc {
  @media screen and (max-width: 830px) {
    display: none;
  }
}
.close-button {
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  width: 87px;
  height: 25px;
  border-radius: 25px;
  background-color: #132839;
  right: 7px;
  top: 10px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: -0.15px;
  text-align: center;
  color: #fff;
  font-family: 'Roboto-Regular';
  @media screen and (max-width: 400px) {
    width: 40px;
  }
  &__text {
    @media screen and (max-width: 400px) {
      display: none;
    }
  }
  img {
    margin-left: 5px;
    margin-top: -2px;
    @media screen and (max-width: 400px) {
      margin-left: 0px;
    }
  }
  &:hover {
    background: rgb(71, 71, 71);
    cursor: pointer;
  }
}
.modal-report {
  width: 956px;
  height: auto;
  overflow: hidden;
  @media screen and (max-width: 1100px) {
    width: 920px;
  }
  @media screen and (max-width: 1030px) {
    width: 830px;
  }
  @media screen and (max-width: 930px) {
    width: 730px;
  }
  @media screen and (max-width: 830px) {
    width: 650px;
  }
  @media screen and (max-width: 768px) {
    width: 650px;
  }
  @media screen and (max-width: 740px) {
    width: 550px;
  }
  @media screen and (max-width: 620px) {
    width: 100%;
  }
  &__header {
    width: 100%;
    height: auto;
  }
  &__for-periods {
    width: 100%;
    height: auto;
    margin-top: 21px;
  }
  &__table-events {
    width: 100%;
    height: auto;
    margin-top: 22px;
  }
  &__table-events-refeere {
    width: 100%;
    margin-top: 21px;
    height: auto;
  }
  &__cont-possession {
    width: 100%;
    height: 303px;
    margin-top: 22px;
    display: inline-flex;
    justify-content: space-between;
    @media screen and (max-width: 830px) {
      display: inline-block;
      height: auto;
    }
    &__noball {
      width: 46.96%;
      height: 303px;
      // background: rgb(243, 243, 243);
      // border: 1px dotted rgb(155, 155, 155);
      @media screen and (max-width: 830px) {
        width: 100%;
      }
    }
    &__withball {
      width: 51.77%;
      height: 303px;
      // background: rgb(243, 243, 243);
      // border: 1px dotted rgb(155, 155, 155);
      @media screen and (max-width: 830px) {
        width: 100%;
        margin-top: 21px;
      }
    }
  }
  &__cont-tables-categories {
    width: 100%;
    height: auto;
    margin-top: 21px;
    display: inline-flex;
    justify-content: space-between;
    @media screen and (max-width: 830px) {
      display: inline-block;
      height: auto;
    }

    &__bandas {
      width: 48.11%;
      height: auto;
      // background: rgb(243, 243, 243);
      // border: 1px dotted rgb(155, 155, 155);
      @media screen and (max-width: 830px) {
        width: 100%;
      }
    }
    &__metas {
      width: 48.11%;
      // background: rgb(243, 243, 243);
      // border: 1px dotted rgb(155, 155, 155);
      height: auto;
      @media screen and (max-width: 830px) {
        width: 100%;
        margin-top: 21px;
      }
    }
  }
  &__cont-btn-export {
    width: 100%;
    height: 40px;
    margin-top: 30px;
  }
  &__cont-title-mobile {
    width: 100%;
    height: 20px;
  }
  &__cont-menu-mobile {
    width: 100%;
    height: 32px;
    margin-top: 8px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  &__cont-generals-mobile {
    width: 100%;
    height: auto;
    margin-top: 8px;
    &__header {
      width: 100%;
      height: 337px;
      @media screen and (max-width: 830px) {
        height: auto;
      }
    }
    &__for-periods {
      width: 100%;
      height: auto;
      margin-top: 14px;
    }
    &__cont-possession {
      width: 100%;
      height: 620px;
      margin-top: 22px;
      display: inline-block;
      &__noball {
        width: 100%;
        height: 303px;
        // background: rgb(243, 243, 243);
        // border: 1px dotted rgb(155, 155, 155);
      }
      &__withball {
        width: 100%;
        height: 303px;
        margin-top: 14px;
        // background: rgb(243, 243, 243);
        // border: 1px dotted rgb(155, 155, 155);
      }
    }
  }
  &__cont-refeeres-mobile {
    width: 100%;
    height: auto;
    margin-top: 8px;
    &__header-refeere {
      margin-top: 6px;
      width: 100%;
      height: auto;
    }
    &__table-events-refeere {
      width: 100%;
      margin-top: 10px;
      height: auto;
    }
  }
  &__cont-events-mobile {
    width: 100%;
    height: auto;
    margin-top: 8px;
    &__table-events {
      width: 100%;
      height: auto;
      margin-top: 6px;
    }
    &__table-bandas {
      width: 100%;
      height: auto;
      margin-top: 16px;
    }
    &__table-saques {
      width: 100%;
      height: auto;
      margin-top: 16px;
    }
  }
}

.modal-card-body {
  padding: 0px 5px 0px 0px !important;
  @media screen and (max-width: 1030px) {
    padding: 0px 0px 0px 0px !important;
  }
  @media screen and (max-width: 400px) {
    padding: 20px 5px 0px 5px !important;
  }
}
.modal-confirm {
  padding: 50px 35px 20px 35px;
  @media screen and (max-width: 1030px) {
    padding: 50px 30px 20px 35px !important;
  }
  @media screen and (max-width: 768px) {
    padding: 50px 15px 20px 15px;
  }
  border-radius: 17px;
  box-shadow: 0 17px 32px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
